import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
import { faLeanpub } from '@fortawesome/free-brands-svg-icons/faLeanpub';
import { faResearchgate } from '@fortawesome/free-brands-svg-icons/faResearchgate';
import { faOrcid } from '@fortawesome/free-brands-svg-icons/faOrcid';
import { faBookmark } from '@fortawesome/free-regular-svg-icons/faBookmark';

// See https://fontawesome.com/icons?d=gallery&s=brands,regular&m=free
// to add other icons.

const data = [
  {
    link: 'https://scholar.google.com/citations?user=EKucrLMAAAAJ',
    label: 'Google Scholar',
    icon: faLeanpub,
  },
  {
    link: 'https://www.researchgate.net/profile/Maria-Diamantopoulou-2',
    label: 'ResearchGate',
    icon: faResearchgate,
  },
  {
    link: 'https://orcid.org/0000-0002-6003-1285',
    label: 'ORCID',
    icon: faOrcid,
  },
  {
    link: 'https://www.scopus.com/authid/detail.uri?authorId=16068059100',
    label: 'Scopus',
    icon: faBookmark,
  },
  {
    link: 'mailto:mdiamant@for.auth.gr',
    label: 'Email',
    icon: faEnvelope,
  },
];

export default data;
